
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[domain]/guide/[[...segments]]",
      function () {
        return require("private-next-pages/[domain]/guide/[[...segments]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[domain]/guide/[[...segments]]"])
      });
    }
  